import React, { PureComponent } from "react";

export default class NoAnswer extends PureComponent {
  render() {
    return (
      <div>
        No response
      </div>
    );
  }
}
